export const LoadingPlaceholder = (props) => {
  return <div style={{ height: props.height, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Loading...</div>
}